import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import { AppBar, IconButton, FormControl, MenuItem, Select, Toolbar } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import _get from 'lodash/get';

import { setLoanType } from '../../routes/Login/state/AuthSlice';

import Notifications from '../Notifications/Notifications';
import Breadcrums from '../Breadcrums/Breadcrums';
import './Header.scss';

const Header = ({ onMenuClick }) => {
  const dispatch = useDispatch();
  const location = useLocation();
  const loan_types = useSelector((state) => _get(state, 'auth.user.loan_types', []));
  const selectedLoanType = useSelector((state) => _get(state, 'auth.user.selected_loan_type', {}));

  const disabledLoanSelectionPaths = [
    '/jobs/',
    '/settings/users',
    '/settings/merchants',
    '/agents/view',
    '/workflows/view',
  ];

  const [selectedOption, setSelectedOption] = useState('');

  const handleSelectChange = (event) => {
    setSelectedOption(event.target.value);
    const selectedType = loan_types?.find((type) => type.id === event.target.value);
    dispatch(setLoanType(selectedType || loan_types[0]));
  };
  useEffect(() => {
    if (!selectedLoanType?.name && loan_types && loan_types.length > 0) {
      setSelectedOption(loan_types[0]?.id);
      dispatch(setLoanType(loan_types[0]));
    } else {
      setSelectedOption(selectedLoanType?.id);
      dispatch(setLoanType(selectedLoanType));
    }
  }, [dispatch, selectedLoanType, loan_types]);

  return (
    <>
      <AppBar position='sticky' className='header-top' color='primary.main' elevation='0'>
        <Toolbar disableGutters className='header-toolbar'>
          <IconButton
            className='menu-toggle'
            edge='start'
            color='inherit'
            aria-label='menu'
            onClick={onMenuClick}
          >
            <MenuIcon />
          </IconButton>

          <Breadcrums />

          <FormControl>
            <Select
              value={selectedOption}
              onChange={handleSelectChange}
              displayEmpty
              disabled={disabledLoanSelectionPaths.some((path) => location.pathname.includes(path))}
              // defaultOpen
              sx={{
                '&.Mui-disabled .MuiOutlinedInput-notchedOutline': {
                  borderColor: 'rgba(0, 0, 0, 0.26)',
                },
                '&.Mui-disabled path': {
                  fill: 'rgba(0, 0, 0, 0.26)',
                },
              }}
            >
              {loan_types?.map((type) => (
                <MenuItem key={type?.id} value={type?.id}>
                  {type?.name}
                </MenuItem>
              ))}
            </Select>
          </FormControl>

          <Notifications />
        </Toolbar>
      </AppBar>
    </>
  );
};

export default Header;
